import React from "react";
import Skeleton from "react-loading-skeleton";

const AVATAR_SIZE = 45;

// One placeholder person row, shaped to <ListRow>'s geometry (45px round avatar, then a name line
// over a subtitle line) so the placeholders sit where the real rows land and nothing reflows when
// the fetch resolves. Singular on purpose: the enclosing list owns the <ul>, the <li>s and the
// divider between them, and only it knows whether this placeholder is inside the real list or in a
// list of its own.
function CompanyPersonRowSkeleton() {
  return (
    <div className="d-flex align-items-center">
      <div className="flex-shrink-0 me-2">
        <Skeleton circle height={AVATAR_SIZE} width={AVATAR_SIZE} />
      </div>
      <div className="flex-grow-1">
        <Skeleton height={16} width="35%" />
        <Skeleton height={12} width="55%" />
      </div>
    </div>
  );
}

export default CompanyPersonRowSkeleton;
